import * as accountsConfig from './constants/accountsConfig'
import * as locations from './constants/locations'
import currencyList from './constants/currencies'
import campaignRoles from './constants/campaignRoles'

export default {
  ...accountsConfig,
  ...locations,
  currencyList,
  campaignRoles,
}
